import { CalendarClock, Disc3, ListMusic, UserRound } from "lucide-react";
import { useMemo, useState } from "react";
import "../../styles/components/collection-card.css";

function formatLastModified(value) {
  if (!value) return "N/A";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "N/A";
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  }).format(date);
}

function PlaylistCard({ title, image, model, onOpenDetails }) {
  const [imageFailed, setImageFailed] = useState(false);
  const hasImage = Boolean(image) && !imageFailed;

  const meta = useMemo(() => {
    const trackCount = Number(model?.track_count) || 0;
    return {
      title: title || "Untitled Playlist",
      creator: model?.user?.username || "Unknown Creator",
      trackCountLabel: `${trackCount} track${trackCount === 1 ? "" : "s"}`,
      updatedLabel: formatLastModified(model?.last_modified),
      description: model?.description || "No description available.",
    };
  }, [model, title]);

  return (
    <article
      className="collection-card collection-card-playlist glass-panel"
      role="button"
      tabIndex={0}
      onClick={() => onOpenDetails?.()}
      onKeyDown={(event) => {
        if (!onOpenDetails) return;
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onOpenDetails();
        }
      }}
      aria-label={`Open playlist details for ${meta.title}`}
    >
      <div className="collection-card-cover-wrap">
        {hasImage ? (
          <img
            className="collection-card-cover"
            src={image}
            alt={meta.title}
            onError={() => setImageFailed(true)}
          />
        ) : (
          <div className="collection-card-fallback" aria-label="No artwork available">
            <Disc3 size={20} />
            <span>No Cover</span>
          </div>
        )}
        <span className="collection-card-type">Playlist</span>
      </div>

      <h3 className="collection-card-title">{meta.title}</h3>

      <p className="collection-card-owner">
        <UserRound size={13} />
        {meta.creator}
      </p>

      <div className="collection-card-meta">
        <span>
          <ListMusic size={13} />
          {meta.trackCountLabel}
        </span>
        <span>
          <CalendarClock size={13} />
          {meta.updatedLabel}
        </span>
      </div>

      <p className="collection-card-description">{meta.description}</p>
    </article>
  );
}

export default PlaylistCard;
